import { EVyplaty } from 'enums/isin/udaje/vyplaty';

const vyplatySelect = [
    {
        value: EVyplaty.D,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_VYPLATY_D'
    },
    {
        value: EVyplaty.Z,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_VYPLATY_Z'
    },
    {
        value: EVyplaty.O,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_VYPLATY_O'
    }
];

export default vyplatySelect;
